import {
  buildCartListBlock,
  buildEventSourceBlock,
  buildOwnerBlock,
  buildProductBlock,
  mergeAmplitudeBlocks,
} from '~/analytics/blocks'
import type { AmplitudePayload, AnalyticsLot, AnalyticsOwner, SourceBlockType } from '~/analytics/blocks/types'
import type { AmplitudePayloadResult, AnalyticsStore, InsurancePageKind } from '~/analytics/composables-types'
import { getGlobalPreviewCatalog } from '~/analytics/composables-types'
import { useCart } from '~/composables/useCart'

interface ViewInsuranceInfoParams {
  store: AnalyticsStore
  lot?: AnalyticsLot | null
  sourceBlockType?: SourceBlockType | string
  pageKind: InsurancePageKind
  lotsOwner?: AnalyticsOwner | null
}

export function getViewInsuranceInfoAmplitudePayload ({
  store,
  lot,
  sourceBlockType,
  pageKind,
  lotsOwner = null,
}: ViewInsuranceInfoParams): AmplitudePayloadResult {
  if (!lot) {
    return buildEventSourceBlock({ sourceBlockType })
  }

  const owner =
    pageKind === 'CART' && lotsOwner
      ? lotsOwner
      : lot.user

  const blocks: Array<Partial<AmplitudePayload>> = [
    buildEventSourceBlock({
      sourcePageName: pageKind === 'CART' ? 'Корзина' : lot.name || '',
      sourcePageType: pageKind === 'CART' ? 'CART' : 'PRODUCT',
      sourceBlockType,
    }),
    buildProductBlock({
      rootGetters: store.getters,
      lot,
      productList: pageKind === 'CART' ? '' : getGlobalPreviewCatalog(),
    }),
    buildOwnerBlock({
      owner,
      ownerCity: lot.city?.name || '',
    }),
  ]

  if (pageKind === 'CART') {
    const cartGetters = useCart().getAnalyticsGetters()
    blocks.push(buildCartListBlock({
      totalCartListSize: cartGetters.totalQuantity,
      cartListCategories: cartGetters.caterogyArray,
    }))
  }

  return mergeAmplitudeBlocks(...blocks)
}
